require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./baseinput"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./baseinput", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./baseinput"), require("./utils")) : factory(root["./baseinput"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__83828__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[2760],{

/***/ 49287:
/***/ ((module) => {

var amdi18n={"__root":{"empty":"Enter a string.","max":"Enter a string that contains %{value} or less characters.","min":"Enter a string that contains at least %{value} characters.","trimStart":"Enter a string that begins with a non-whitespace character.","trimEnd":"Enter a string that ends with a non-whitespace character."},"__cs":{"empty":"Zadejte platný řetězec.","max":"Zadejte řetězec, který obsahuje %{value} nebo méně znaků.","min":"Zadejte řetězec, který obsahuje alespoň %{value} znaků.","trimStart":"Zadejte řetězec, který začíná nemezerovým znakem.","trimEnd":"Zadejte řetězec, který končí nemezerovým znakem."},"__da":{"empty":"Angiv en gyldig streng.","max":"Angiv en streng, der indeholder %{value} eller færre tegn.","min":"Angiv en streng, der indeholder mindst %{value} tegn.","trimStart":"Angiv en streng, der begynder med et ikke-blanktegn.","trimEnd":"Angiv en streng, der slutter med et ikke-blanktegn."},"__de":{"empty":"Geben Sie eine gültige Zeichenfolge ein. ","max":"Geben Sie eine Zeichenfolge mit maximal %{value} Zeichen ein. ","min":"Geben Sie eine Zeichenfolge mit mindestens %{value} Zeichen ein. ","trimStart":"Geben Sie eine Zeichenfolge ein, die nicht mit einem Leerzeichen beginnt. ","trimEnd":"Geben Sie eine Zeichenfolge ein, die nicht mit einem Leerzeichen endet. "},"__es":{"empty":"Escriba una serie válida. ","max":"Escriba una serie que contenga %{value} o menos caracteres. ","min":"Escriba una serie que contenga al menos %{value} caracteres. ","trimStart":"Escriba una serie que comience con un carácter que no sea un espacio en blanco. ","trimEnd":"Escriba una serie que acabe con un carácter que no sea un espacio en blanco. "},"__fi":{"empty":"Anna kelvollinen merkkijono.","max":"Anna merkkijono, jossa on enintään %{value} merkkiä.","min":"Anna merkkijono, jossa on vähintään %{value} merkkiä.","trimStart":"Anna merkkijono, joka alkaa muulla kuin tyhjämerkillä.","trimEnd":"Anna merkkijono, joka päättyy muuhun kuin tyhjämerkkiin."},"__fr":{"empty":"Entrez une chaîne valide.","max":"Entrez une chaîne de %{value} caractères ou moins.","min":"Entrez une chaîne d'au moins %{value} caractères.","trimStart":"Entrez une chaîne commençant par un caractère différent d'un espace.","trimEnd":"Entrez une chaîne se terminant par un caractère différent d'un espace."},"__hr":{"empty":"Molim, unesite važeći niz znakova.","max":"Unesite niz koji sadrži %{value} ili manje znakova.","min":"Unesite niz koji sadrži najmanje %{value} znakova.","trimStart":"Unesite niz znakova koji počinje s nepraznim znakom.","trimEnd":"Unesite niz koji završava s nepraznim znakom."},"__hu":{"empty":"Adjon meg egy érvényes karaktersorozatot. ","max":"Adjon meg egy legfeljebb %{value} karaktert tartalmazó karaktersorozatot. ","min":"Adjon meg egy legalább %{value} karaktert tartalmazó karaktersorozatot. ","trimStart":"Adjon meg egy nem szóköz karakterrel kezdődő karaktersorozatot. ","trimEnd":"Adjon meg egy nem szóköz karakterrel végződő karaktersorozatot. "},"__it":{"empty":"Immettere una stringa valida.","max":"Immettere una stringa che non contenga più di %{value} caratteri. ","min":"Immettere una stringa che contenga almeno %{value}.","trimStart":"Immettere una stringa che non inizi con un carattere vuoto.","trimEnd":"Immettere una stringa che non termini con un carattere vuoto."},"__ja":{"empty":"有効な文字列を入力してください。","max":"文字数が %{value} 以内の文字列を入力してください。","min":"文字数が %{value} 以上の文字列を入力してください。","trimStart":"空白文字以外で始まる文字列を入力してください。","trimEnd":"空白文字以外で終わる文字列を入力してください。"},"__kk":{"empty":"Жарамды жолды енгізіңіз.","max":"%{value} немесе одан аз таңбалардан тұратын жолды енгізіңіз.","min":"Кемінде %{value} таңбаларынан тұратын жолды енгізіңіз.","trimStart":"Бос емес таңбадан басталатын жолды енгізіңіз.","trimEnd":"Бос емес таңбамен аяқталатын жолды енгізіңіз."},"__ko":{"empty":"올바른 문자열을 입력하십시오.","max":"%{value}자 이하의 문자가 포함된 문자열을 입력하십시오.","min":"%{value}자 이상의 문자가 포함된 문자열을 입력하십시오.","trimStart":"공백이 아닌 문자로 시작하는 문자열을 입력하십시오.","trimEnd":"공백이 아닌 문자로 끝나는 문자열을 입력하십시오."},"__nb":{"empty":"Oppgi en gyldig streng.","max":"Oppgi en streng som inneholder %{value} eller færre tegn.","min":"Oppgi en streng som inneholder minst %{value} tegn.","trimStart":"Oppgi en streng som begynner med et tegn som ikke er et blanktegn.","trimEnd":"Oppgi en streng som slutter med et tegn som ikke er et blanktegn."},"__nl":{"empty":"Geef een geldige tekenreeks op.","max":"Geef een tekenreeks op die %{value} of minder tekens bevat.","min":"Geef een tekenreeks op die ten minste %{value} tekens bevat.","trimStart":"Geef een tekenreeks op die niet begint met een teken voor witruimte.","trimEnd":"Geef een tekenreeks op die niet eindigt met een teken voor witruimte."},"__no":{"empty":"Oppgi en gyldig streng.","max":"Oppgi en streng som inneholder %{value} eller færre tegn.","min":"Oppgi en streng som inneholder minst %{value} tegn.","trimStart":"Oppgi en streng som begynner med et tegn som ikke er et blanktegn.","trimEnd":"Oppgi en streng som slutter med et tegn som ikke er et blanktegn."},"__pl":{"empty":"Wprowadź poprawny łańcuch.","max":"Wprowadź łańcuch zawierający nie więcej niż %{value} znaków.","min":"Wprowadź łańcuch zawierający co najmniej %{value} znaków.","trimStart":"Wprowadź łańcuch, który rozpoczyna się od znaku innego niż biały znak.","trimEnd":"Wprowadź łańcuch, który kończy się znakiem innym niż biały znak."},"__pt":{"empty":"Insira uma sequência válida.","max":"Insira uma sequência que contenha %{value} caracteres ou menos.","min":"Insira uma sequência que contenha ao menos %{value} caracteres.","trimStart":"Insira uma sequência que comece com um caractere diferente de um espaço em branco.","trimEnd":"Insira uma sequência que termine com um caractere diferente de um espaço em branco."},"__pt-br":{"empty":"Insira uma sequência válida.","max":"Insira uma sequência que contenha %{value} caracteres ou menos.","min":"Insira uma sequência que contenha ao menos %{value} caracteres.","trimStart":"Insira uma sequência que comece com um caractere diferente de um espaço em branco.","trimEnd":"Insira uma sequência que termine com um caractere diferente de um espaço em branco."},"__ro":{"empty":"Vă rugăm introduceţi un şir valid. ","max":"Introduceţi un şir care conţine %{value} caractere sau mai puţine. ","min":"Introduceţi un şir care conţine cel puţin %{value} caractere. ","trimStart":"Introduceţi un şir care începe cu un caracter care nu este blanc. ","trimEnd":"Introduceţi un şir care se termină cu un caracter care nu este blanc. "},"__ru":{"empty":"Введите допустимую строку символов.","max":"Веедите строку, содержащую %{value} или меньше символов.","min":"Веедите строку, содержащую как минимум %{value} символов.","trimStart":"Веедите строку символов, не начинающуюся с пробела.","trimEnd":"Веедите строку символов, не заканчивающуюся пробелом."},"__sl":{"empty":"Vnesite veljaven niz.","max":"Vnesite niz, ki vsebuje toliko znakov ali manj: %{value}.","min":"Vnesite niz, ki vsebuje vsaj toliko znakov: %{value}.","trimStart":"Vnesite niz, ki se začne z znakom, ki ni presledek.","trimEnd":"Vnesite niz, ki se konča z znakom, ki ni presledek."},"__sv":{"empty":"Ange en giltig sträng.","max":"Ange en sträng som innehåller högst %{value} tecken.","min":"Ange en sträng som innehåller minst %{value} tecken.","trimStart":"Ange en sträng som börjar med ett tecken som inte är osynligt.","trimEnd":"Ange en sträng som slutar med ett tecken som inte är osynligt."},"__th":{"empty":"โปรดป้อนสตริงที่ถูกต้อง","max":"ป้อนสตริงที่มี %{value} อักขระหรือน้อยกว่า","min":"ป้อนสตริงที่มีอย่างน้อย %{value} อักขระ","trimStart":"ป้อนสตริงที่ขึ้นต้นด้วยอักขระที่ไม่ใช่ whitespace","trimEnd":"ป้อนสตริงที่ลงท้ายด้วยอักขระที่ไม่ใช่ whitespace"},"__tr":{"empty":"Lüfen geçerli bir dizgi girin. ","max":"%{value} ya da daha az karakter içeren bir dizgi girin. ","min":"En az %{value} karakter içeren bir dizgi girin. ","trimStart":"Boşluk olmayan karakteri ile başlayan bir dizgi girin. ","trimEnd":"Boşluk olmayan karakteri ile biten bir dizgi girin. "},"__zh":{"empty":"请输入有效字符串。","max":"请输入包含 %{value} 或更少字符的字符串。","min":"请输入至少包含 %{value} 字符的字符串。","trimStart":"请输入不以空格字符开头的字符串。","trimEnd":"请输入不以空格字符结尾的字符串。"},"__zh-cn":{"empty":"请输入有效字符串。","max":"请输入包含 %{value} 或更少字符的字符串。","min":"请输入至少包含 %{value} 字符的字符串。","trimStart":"请输入不以空格字符开头的字符串。","trimEnd":"请输入不以空格字符结尾的字符串。"},"__zh-hk":{"empty":"請輸入有效字串。","max":"輸入包含 %{value} 或較少字元的字串。","min":"輸入至少包含 %{value} 個字元的字串。","trimStart":"輸入以非空格字元為開頭的字串。","trimEnd":"輸入以非空格字元為結尾的字串。"},"__zh-mo":{"empty":"請輸入有效字串。","max":"輸入包含 %{value} 或較少字元的字串。","min":"輸入至少包含 %{value} 個字元的字串。","trimStart":"輸入以非空格字元為開頭的字串。","trimEnd":"輸入以非空格字元為結尾的字串。"},"__zh-sg":{"empty":"请输入有效字符串。","max":"请输入包含 %{value} 或更少字符的字符串。","min":"请输入至少包含 %{value} 字符的字符串。","trimStart":"请输入不以空格字符开头的字符串。","trimEnd":"请输入不以空格字符结尾的字符串。"},"__zh-tw":{"empty":"請輸入有效字串。","max":"輸入包含 %{value} 或較少字元的字串。","min":"輸入至少包含 %{value} 個字元的字串。","trimStart":"輸入以非空格字元為開頭的字串。","trimEnd":"輸入以非空格字元為結尾的字串。"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 98263:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _baUiCarbon = __webpack_require__(6536);
var _utils = __webpack_require__(78815);
var _baseinput = _interopRequireDefault(__webpack_require__(83828));
var _StringResource = _interopRequireDefault(__webpack_require__(52338));
var _TextInput = _interopRequireDefault(__webpack_require__(43941));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  sanitize,
  getInheritedProps
} = _utils.propsUtils;
const _CLASS = _TextInput.default.textInputClassName.replace(/"/g, ''); // eslint-disable-line no-underscore-dangle

// accept only a valid string as input
const fixupValue = (value, _ref) => {
  let {
    type
  } = _ref;
  if (type === 'password' || value === undefined) {
    return undefined;
  }
  if (typeof value === 'number') {
    return String(value);
  }
  if (typeof value === 'string') {
    return value;
  }
  return '';
};

// check value; and return a bound value and message when applicable
const checkValue = (value, _ref2) => {
  let {
    allowEmpty
  } = _ref2;
  if ((value != null ? value : '') === '') {
    if (allowEmpty) {
      return {
        value: '',
        message: undefined
      };
    }
    return {
      value: undefined,
      message: _StringResource.default.get('empty')
    };
  }
  return {
    value,
    message: undefined
  };
};
class TextInput extends _react.Component {
  constructor(_props) {
    super(_props);
    (0, _defineProperty2.default)(this, "_useOnValueCallbacks", !!this.props.onValueChange || !!this.props.onValueAccept);
    (0, _defineProperty2.default)(this, "_ref", input => {
      this._input = input;
    });
    (0, _defineProperty2.default)(this, "_onValueChange", newValue => {
      const {
        onValueChange
      } = this.props;
      const {
        value,
        message
      } = checkValue(newValue, this.props);
      this.setState({
        displayValue: newValue,
        message
      });

      // if the input is or can be valid
      if (value !== undefined) {
        // if there is additional processing, call it
        onValueChange && onValueChange(value, newValue);
      }
    });
    (0, _defineProperty2.default)(this, "_onChange", (newValue, finalFireOnBlur) => {
      const {
        onChange,
        fireOnBlur,
        value
      } = this.props;
      this.setState({
        displayValue: finalFireOnBlur ? value : newValue
      });
      (!fireOnBlur || finalFireOnBlur && newValue !== value) && (onChange == null ? void 0 : onChange(newValue));
    });
    (0, _defineProperty2.default)(this, "_onBlur", e => {
      const {
        onBlur,
        value,
        fireOnBlur
      } = this.props;
      this.setState({
        displayValue: value
      });
      fireOnBlur && this._onChange(e.currentTarget.value, true);
      onBlur == null ? void 0 : onBlur(e);
    });
    (0, _defineProperty2.default)(this, "_onValueAccept", newValue => {
      const {
        value,
        onValueAccept
      } = this.props;
      const oldValue = fixupValue(value, this.props);
      const {
        value: newBoundValue
      } = checkValue(newValue, this.props);
      const {
        value: oldBoundValue,
        message
      } = checkValue(oldValue, this.props);
      this.setState({
        displayValue: oldValue,
        message
      });

      // check if the old value does not match the new bound value
      if (oldBoundValue !== newBoundValue) {
        // if there is additional processing, call it
        onValueAccept && onValueAccept(newBoundValue, newValue);
      }
    });
    (0, _defineProperty2.default)(this, "_inputToRender", props =>
    /*#__PURE__*/
    // eventually/hopefully the props sent via BaseInput can be done directly here
    _react.default.createElement(_baUiCarbon.TextInput, props));
    this.state = {
      displayValue: undefined,
      message: undefined
    };
  }
  componentDidMount() {
    const {
      value
    } = this.props;
    const fixedNewValue = fixupValue(value, this.props);
    const {
      message
    } = checkValue(fixedNewValue, this.props);
    this.setState({
      displayValue: fixedNewValue,
      message
    });
  }
  componentWillReceiveProps(_ref3) {
    let {
      value: newValue
    } = _ref3;
    const {
      value: oldValue
    } = this.props;
    const fixedOldValue = fixupValue(oldValue, this.props);
    const fixedNewValue = fixupValue(newValue, this.props);
    const {
      message
    } = checkValue(fixedNewValue, this.props);

    // this.setState({ message });
    if (fixedNewValue !== fixedOldValue) {
      this.setState({
        displayValue: fixedNewValue,
        message
      });
    }
  }

  // eventually/hopefully onValueChange/onValueAccept will be the norm, and useOnValueCallbacks can be removed

  focus() {
    const {
      disabled
    } = this.props;
    !disabled && this._input && this._input.focus();
  }
  render() {
    // extract props that are to be manipulated or not passed down
    const {
      // textInput specific
      inputChildren,
      // inherited props
      type,
      dir,
      textDir,
      className,
      validationErrorText,
      hasValidationError,
      onChange,
      onBlur,
      // get all the other props
      ...others
    } = this.props;
    const {
      displayValue,
      message
    } = this.state;
    const mappedMessage = this._useOnValueCallbacks && message ? message : undefined;
    return (
      /*#__PURE__*/
      // ideally baseInput is only a temporary wrapper to handle error handling
      // as such the only props that should need to be sent to it are those dealing with message handling
      _react.default.createElement(_baseinput.default, (0, _extends2.default)({
        inputToRender: this._inputToRender,
        className: `${_CLASS} ${className}`,
        "data-tid": _CLASS
      }, sanitize(others, TextInput), getInheritedProps(others, _baseinput.default), {
        ref: this._ref
      }, dir ? {
        dir
      } : {}, textDir ? {
        textDir
      } : {}, {
        value: displayValue,
        onBlur: this._useOnValueCallbacks ? onBlur : this._onBlur,
        onChange: this._useOnValueCallbacks ? onChange : this._onChange,
        onValueChange: this._useOnValueCallbacks ? this._onValueChange : undefined,
        onValueAccept: this._useOnValueCallbacks ? this._onValueAccept : undefined,
        validationErrorText: mappedMessage || validationErrorText,
        hasValidationError: mappedMessage ? true : hasValidationError,
        type: type != null ? type : 'text'
      }), inputChildren)
    );
  }
}
exports["default"] = TextInput;
(0, _defineProperty2.default)(TextInput, "propTypes", {
  ..._baseinput.default.propTypes,
  // these props have a different definition then the baseInput props
  type: _propTypes.default.oneOf(['password']),
  value: _propTypes.default.oneOfType([_propTypes.default.string]),
  // these props are in addition to the baseInput props
  inputChildren: _propTypes.default.node
});
(0, _defineProperty2.default)(TextInput, "defaultProps", {
  className: '',
  style: {},
  allowEmpty: true
});

/***/ }),

/***/ 49930:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _TextInput = _interopRequireDefault(__webpack_require__(98263));
exports["default"] = _TextInput.default;
exports.TextInput = _TextInput.default;

/***/ }),

/***/ 52338:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _TextInputResources = _interopRequireDefault(__webpack_require__(49287));
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_TextInputResources.default);

/***/ }),

/***/ 17918:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"textInputClassName": "\"ba-common-textInput\""
};

/***/ }),

/***/ 43941:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TextInput_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17918);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TextInput_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TextInput_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TextInput_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TextInput_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TextInput_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TextInput_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TextInput_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TextInput_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 6536:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 83828:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__83828__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(49930));
/******/ return __webpack_exports__;
/******/ }
]);
});